<template>
  <v-dialog v-model="show" persistent width="500">
    <v-card>
      <v-card-title>
        <h2>Confirm delete {{ product.name_zh_hk}}?</h2>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text v-if="msg !== null">
        <v-alert :value="true" :type="error ? 'error' : 'success'">{{ msg }}</v-alert>
      </v-card-text>
      <v-card-actions>
        <v-btn color="default" @click="cancel()" :loading="loading">Cancel</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="error" @click="confirm()" :loading="loading">Delete</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import productService from '@/services/product'

export default {
  props: {
    product: Object
  },

  data () {
    return {
      loading: false,
      error: false,
      msg: null
    }
  },

  computed: {
    show () {
      return this.product.hasOwnProperty('id')
    }
  },

  methods: {
    async confirm () {
      this.loading = true
      this.error = false
      this.msg = null

      const {data} = await productService.delete(this.product.id)
      this.msg = data.message

      if (data.status !== 'success') {
        this.loading = false
        this.error = true
        return
      }

      setTimeout(() => {
        this.$emit('done')
      }, 1000)
    },

    cancel () {
      this.$emit('cancel')
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Product/Delete.vue